import '@babel/polyfill'
import Vue from 'vue'
import Firebase from 'firebase'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.config.productionTip = false

const config = {
    apiKey: "AIzaSyBEeEqUIc-dUih6cINULQqLYegadNL0j8c",
    authDomain: "paw-fin.firebaseapp.com",
    databaseURL: "https://paw-fin.firebaseio.com",
    projectId: "paw-fin",
    storageBucket: "paw-fin.appspot.com",
    messagingSenderId: "257191091489"
  };

Firebase.initializeApp(config);

router.beforeEach((to, from, next) => {

  const currentUser = Firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next('/');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }

});

Firebase.auth().onAuthStateChanged(function (user) {

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

});
